import { useQueryClient } from "@tanstack/react-query";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";
import {
  type TitleJournalMutateOptions,
  withTitleJournalInvalidation,
} from "./invalidate-title-journal-queries";

interface IUseReturnTitleJournal {
  titleId: string;
}

export function useReturnTitleJournal({ titleId }: IUseReturnTitleJournal) {
  const queryClient = useQueryClient();
  const mutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/status/return",
  );

  return {
    ...mutation,
    mutate: (mutateOptions?: TitleJournalMutateOptions) => {
      mutation.mutate(
        {
          params: {
            path: { titleId },
          },
        },
        withTitleJournalInvalidation(queryClient, titleId, mutateOptions),
      );
    },
  };
}
